export default "__VITE_ASSET__bYSYh2Km__"